import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTable(theme: Theme): MuiThemeComponentOverride<"MuiTable"> {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          border: `1px solid ${theme.palette.brand.grey[200].main ?? "transparent"}`,
        },
      },
    },
  };
}
